import { Arbejdsgang } from "../arbejdsgang/model/arbejdsgang.model";
import { OpgaveInstallation } from "./opgave-installation.model";

export const opgaveVersion = 2;

export class Opgave {
    public arbejdsgange: Arbejdsgang[];
    public id: number;
    public installation: OpgaveInstallation;
    public navn: string;
    public paabegyndt: Date; // Tidspunkt hvor opgaven er påbegyndt i E|Forsyning
    public uid: string; // Unik id, som oprettes når man påbegynder en opgave
    public version: number; // Version defineret af E|Forsyning, så vi kan hente ældre version fra localStorage og opgradere den.
}
